import UserInformation from './common/UserInformation'
import React from 'react'
import BankInformation from './common/BankInformation'
import ProducerOtherData from './producer/ProducerOtherData'
import ConsumerOtherData from './consumer/ConsumerOtherData'
import ProducerGenerationPlantDetails from './producer/ProducerGenerationPlantDetails'
import ConsumerGenerationPlantDetails from './consumer/ConsumerGenerationPlantDetails'
import { Grid } from '@mui/material'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import LogoLoader from '../../../../components/LogoLoader'

const PaperItem = styled(Paper)`
  && {
    background-color: transparent;
    margin-top: 30px;
  }
`

/**
 * This component renders the appropriate details view based on contract type (Consumer or Producer)
 *
 * @param {object} contract - Contains the user's contract data from the new API
 * @param {string} contract.uuid - Unique identifier for the contract
 * @param {string} contract.contractNumber - Contract number
 * @param {string} contract.firstName - User's first name
 * @param {string} contract.lastName - User's last name
 * @param {string} contract.email - User's email address
 * @param {string} contract.phone - User's phone number
 * @param {string} contract.salutation - Salutation (MR, MRS, COMPANY)
 * @param {string} contract.dateOfBirth - User's date of birth
 * @param {string} contract.energyRole - Type of contract ('PRODUCER' or 'CONSUMER')
 * @param {string} contract.contractStatus - Contract status (ACTIVE, INACTIVE, IN_PROGRESS)
 * @param {string} contract.contractType - Contract type (B2C, B2B)
 * @param {object} contract.address - Primary address information
 * @param {object} contract.billingAddress - Billing address information
 * @param {object} contract.paymentDetails - Payment information
 * @param {object} contract.plantAddress - Plant address (for producers)
 * @param {string} contract.plantName - Plant name (for producers)
 * @param {string} contract.plantKey - Plant key (for producers)
 * @param {number} contract.installedPowerKw - Installed power in kW (for producers)
 * @param {string} contract.energyPlantType - Type of energy plant (for producers)
 * @param {string} contract.commissioningDate - Commission date (for producers)
 * @param {string} contract.marketLocation - Market location (for producers)
 * @param {string} contract.meterNumber - Meter number (for producers)
 * @param {string} contract.gridOperator - Grid operator (for producers)
 * @param {string} contract.registeredCourt - Registered court (for companies)
 * @param {string} contract.registrationNumber - Registration number (for companies)
 * @param {boolean} contract.isSalesTaxLiable - Sales tax liability (producer contracts)
 * @param {boolean} contract.isMarketingInformationConsentGiven - Marketing consent
 * @param {boolean} contract.isTermsAndConditionsAccepted - Terms acceptance
 * @param {boolean} contract.isPlantTermsAndConditionsAccepted - Plant terms acceptance
 */
const ContractDetails = ({ contract }) => {
  const isProducer = contract?.energyRole === 'PRODUCER'

  return (
    <>
      {contract ? (
        <>
          <PaperItem>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={5.5}>
                <UserInformation contract={contract} />
              </Grid>
              <Grid item xs={12} sm={5.5}>
                {isProducer ? (
                  <ProducerGenerationPlantDetails contract={contract} />
                ) : (
                  <ConsumerGenerationPlantDetails contract={contract} />
                )}
              </Grid>
              <Grid item xs={12} sm={5.5}>
                {isProducer ? (
                  <ProducerOtherData contract={contract} />
                ) : (
                  <ConsumerOtherData contract={contract} />
                )}
              </Grid>
              <Grid item xs={12} sm={5.5}>
                <BankInformation contract={contract} />
              </Grid>
            </Grid>
          </PaperItem>
        </>
      ) : (
        <LogoLoader loading={true} />
      )}
    </>
  )
}

export default ContractDetails
